// extracted by mini-css-extract-plugin
module.exports = {"label":"inputs_label__L5snS"};